module.exports = __webpack_public_path__ + "static/media/ic_file.043d3335.svg";